import { Progress } from "@/components/ui/progress";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PHASE_LABELS } from "@/utils/deals.utils";
import { dealProgress, formatMoney } from "@/utils/deals.utils";
import SectionCard from "@/components/common/SectionCard";
import type { Deal } from "@/types/deals.types";

interface DealTableProps {
  deals: Deal[];
}

export default function DealTable({ deals }: DealTableProps) {
  return (
    <SectionCard className="overflow-hidden rounded-2xl" contentClassName="p-0" data-testid="deal-table">
      <Table>
        <TableHeader>
          <TableRow className="bg-dash-searchBg hover:bg-dash-searchBg">
            <TableHead className="px-5">Property</TableHead><TableHead>Client</TableHead><TableHead>Stage</TableHead><TableHead>Status</TableHead><TableHead>Progress</TableHead><TableHead className="pr-5 text-right">Value</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {deals.map((deal) => (
            <TableRow key={deal.id} className="cursor-pointer" onClick={() => window.location.assign(`/deals/${deal.id}`)}>
              <TableCell className="px-5 py-4 font-semibold text-dash-ink">{deal.address}</TableCell>
              <TableCell className="text-dash-muted">{deal.client_name}</TableCell>
              <TableCell className="text-dash-muted">{PHASE_LABELS[deal.phase]}</TableCell>
              {/* Brief 1.14: a plain rule-backed sentence, not an "At risk" badge.
                  `health_signals` is server-computed ("2 overdue tasks", "Closing
                  within a week"); a green deal simply reads "On track". */}
              <TableCell className="text-dash-muted">{deal.health_signals?.[0] || "On track"}</TableCell>
              <TableCell className="min-w-36"><div className="flex items-center gap-2"><Progress value={dealProgress(deal)} className="h-1.5 bg-dash-chip [&>div]:bg-dash-greenMid" /><span className="text-xs text-dash-faint">{dealProgress(deal)}%</span></div></TableCell>
              <TableCell className="pr-5 text-right font-medium">{formatMoney(deal.contract_price || deal.list_price) || "—"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </SectionCard>
  );
}
